import * as React from 'react';
import * as styles from './MainContentWrapper.css';

interface IMainContentWrapperProps {
  children: React.ReactNode;
}

export function MainContentWrapper({ children }: IMainContentWrapperProps) {
  return <div className={styles['container']}>{children}</div>;
}
